module.exports = __webpack_public_path__ + "static/media/icon_arrow.5e1660f6.svg";